'use strict';

/*global app*/
/*global services*/
/*global initialize*/
/*global invokeCallback*/
/*global btArticle*/
/*global resClose*/
/*global resSuccess*/
/*global weightNetto*/
/*global weightBrutto*/
/*global parseFloatK2*/

function ArticleService() {
  this.modal = null;
  this.callback = null;

  this.searchArticleTimeout = null;
  this.lastSearchArticle = null;
  this.init();
}

ArticleService.prototype = $.extend({}, {
  constructor: 'ArticleService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.article__show-replacements', function () {
      _this.showReplacements($(this).data('jcitem_rid'), $(this).data('article_id'), $(this).data('tag'));

      return false;
    });

    $('body').on('click', '.article__use-replacement', function () {
      _this.useReplacement($(this).data('article_id'), $(this).data('quantity_ratio'));

      return false;
    });

    $('body').on('keyup change', '.article__find-input', function () {
      var $input = $(this);

      if (_this.lastSearchArticle !== $input.val()) {
        clearTimeout(_this.searchArticleTimeout);

        _this.searchArticleTimeout = setTimeout(function () {
          _this.lastSearchArticle = $input.val();
          _this.searchArticles($input.val());
        }, 350);
      }
    });

    $('body').on('click', '.article__find-select', function () {
      _this.selectArticle($(this).closest('.article__find-row').data('id'));

      return false;
    });

    $('body').on('click', '.article__print-material-serial-number', function () {
      _this.printMaterialSerialNumber();

      return false;
    });

    $('body').on('click', '.article__change-weight--netto', function () {
      _this.changeWeight($(this).data('article_id'), weightNetto);

      return false;
    });

    $('body').on('click', '.article__change-weight--brutto', function () {
      _this.changeWeight($(this).data('article_id'), weightBrutto);

      return false;
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  searchArticles: function searchArticles(searchValue) {
    var _this = this;

    if (!$.trim(searchValue)) {
      _this.modal.contentDOM().find('.article__find-items').html('');

      return _this;
    }

    _this.modal.block();
    app.get(app.path('article_do_find', { SearchValue: searchValue }), function (res) {
      _this.modal.unBlock();

      if (res.msg === 'SUCCESS') {
        _this.modal.contentDOM().find('.article__find-items').html(res.data.html);
      } else if (res.msg === 'NOT_VALID') {
        app.viewWarningMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  selectArticle: function selectArticle(id) {
    var _this = this;

    _this.modal.close();

    _this.callback(id);

    return _this;
  },

  //----------------------------------------------------------------------------

  get: function get(articleId, callback) {
    var _this = this;

    app.getFormation('production_article:get', { ArticleId: articleId }, function (res) {
      if (res.msg === 'SUCCESS') {
        callback(res.data);
      } else if (res.msg === 'NOT_VALID') {
        app.viewWarningMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  find: function find(callback) {
    var _this = this;

    _this.callback = callback;

    _this.modal.open({
      height: 'auto',
      width: 'lg',
    });

    _this.modal.block();
    app.get(app.path('article_find'), function (res) {
      _this.modal.unBlock();

      if (res.msg === 'SUCCESS') {
        _this.modal.content(res.data.html);

        initialize(_this.modal.contentDOM());
      } else if (res.msg === 'NOT_VALID') {
        app.viewWarningMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  showReplacements: function showReplacements(jcItemRID, articleId, tag) {
    var _this = this;

    _this.modal.open({
      height: 'auto'
    });

    _this.modal.block();
    app.get(app.path('article_replacements', { JCItemRID: jcItemRID, ArticleId: articleId }), function (res) {
      _this.modal.unBlock();

      if (res.msg === 'SUCCESS') {
        _this.modal.content(res.data.html);
        _this.modal.contentDOM().data('tag', tag);
      } else if (res.msg === 'NOT_VALID') {
        app.viewWarningMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  useReplacement: function useReplacement(articleId, quantityRatio) {
    var _this = this;

    _this.modal.block();

    _this.get(articleId, function (data) {
      data.tag = _this.modal.contentDOM().data('tag');
      data.quantityRatio = quantityRatio;

      _this.modal.unBlock();
      _this.modal.close(function () {
        $('body').trigger('article-use-replacement', data);
      });
    });

    return _this;
  },

  doPrintMaterialSerialNumber: function doPrintMaterialSerialNumber(articleId, callback) {
    var _this = this;

    //app.getValue({ content: app.t('insert_quantity_to_print'), value: 1 }, function (quantity) {

    var quantity = 1;
    app.getValue({ content: app.t('insert_quantity_stickers_to_print'), value: 1 }, function (count) {
      app.getFormation('production_article:print_material_serial_number', { ArticleId: articleId, Quantity: quantity, Count: count, WorkplaceRID: app.param('workplace_rid') }, function (res) {
        if (res.msg === 'SUCCESS') {
          app.viewSuccessMessage();

          invokeCallback(callback);
        } else {
          app.viewErrorMessage(res.error, function () {
            invokeCallback(callback);
          });
        }
      });
    });

    //});

    return _this;
  },

  printMaterialSerialNumber: function printMaterialSerialNumber() {
    var _this = this;

    services.get('barcode').scanAndFindBarcode(btArticle, {}, 0, function (res, data) {
      if (res === resClose) {
        return;
      }

      if (res !== resSuccess) {
        app.showMessageHtml(app.t('barcode.not_found'), function () {
          _this.printMaterialSerialNumber();
        });

        return;
      }

      _this.doPrintMaterialSerialNumber(data.Id);
    });

    return _this;
  },

  changeWeight: function changeWeight(articleId, weightType, callback) {
    var _this = this;

    var translation = app.t('article.change_weight');

    switch (weightType) {
      case weightNetto : {
        translation = app.t('article.change_weight_netto');
      }

      break;

      case weightBrutto : {
        translation = app.t('article.change_weight_brutto');
      }

      break;
    }

    app.getValue({ content: translation }, function (weight) {
      weight = parseFloatK2(weight);

      app.getFormation('article:save_weight', { ArticleId: articleId, Weight: weight, WeightType: weightType }, function (res) {
        var data = {
          articleId: articleId,
          weight: res.msg === 'SUCCESS' ? weight : -1,
          weightType: weightType
        };

        if (res.msg !== 'SUCCESS') {
          app.viewErrorMessage(res.error);
        }

        invokeCallback(callback, data.weight);
        $('body').trigger('article-change-weight', data);
      });
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.modal = services.get('modal');

    _this.registerCallbacks();

    return _this;
  }
});
